import CloseIcon from "@mui/icons-material/Close";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
    Box,
    Collapse,
    Drawer,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemButton,
    Typography
} from "@mui/material";
import React, { useState } from "react";
import {
    urlToCatalogHome,
    urlToContactUs,
    urlToHome,
    urlToRentals,
    urlToRepairs
} from "../../Routing";
import { iNavItem } from "./Navigation";

export const MobileNavItem: React.FC<
    React.PropsWithChildren<{ href: string }>
> = (props) => {
    return (
        <Link
            underline="none"
            href={props.href}
            sx={{
                display: "block",
                fontSize: "14px",
                textTransform: "uppercase",
                fontFamily: "Montserrat",
                textDecoration: "none",
                color: "white"
            }}
        >
            {props.children}
        </Link>
    );
};

interface MobileMenuProps {
    open: boolean;
    floorProducts: iNavItem[];
    equipment: iNavItem[];
    about: iNavItem[];
    resources: iNavItem[];
    onClose?(): void;
}

export const MobileMenu: React.FC<React.PropsWithChildren<MobileMenuProps>> = (
    props
) => {
    const { floorProducts, equipment, about, resources } = props;
    const container =
        window !== undefined ? () => window.document.body : undefined;
    const [productListOpen, setProductListOpen] = useState(false);
    const [equipmentListOpen, setEquipmentListOpen] = useState(false);
    const [aboutOpen, setAboutOpen] = useState(false);
    const [resourcesOpen, setResourcesOpen] = useState(false);

    function toggleProductList() {
        setProductListOpen((prevState) => !prevState);
    }

    function toggleEquipmentList() {
        setEquipmentListOpen((prevState) => !prevState);
    }

    function toggleAbout() {
        setAboutOpen((prevState) => !prevState);
    }

    function toggleResources() {
        setResourcesOpen((prevState) => !prevState);
    }

    return (
        <Drawer
            container={container}
            variant="temporary"
            open={props.open}
            onClose={props.onClose}
            ModalProps={{
                keepMounted: true // Better open performance on mobile.
            }}
            sx={{
                display: { xs: "block", md: "none" },
                "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: { xs: "75%", sm: "50%" },
                    backgroundColor: "#0C173C"
                }
            }}
        >
            <Box>
                <Box
                    onClick={props.onClose}
                    style={{ textAlign: "right", padding: "12px 12px" }}
                >
                    <IconButton onClick={props.onClose}>
                        <CloseIcon
                            sx={{ width: "40px", height: "40px" }}
                            htmlColor="white"
                        />
                    </IconButton>
                </Box>
                <List>
                    <ListItem key="mobile_home">
                        <ListItemButton sx={{ textAlign: "left" }}>
                            <MobileNavItem href={urlToHome}>Home</MobileNavItem>
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="mobile_products" onClick={toggleProductList}>
                        <ListItemButton
                            sx={{ textAlign: "left", display: "block" }}
                        >
                            <Typography
                                color="primary"
                                sx={{
                                    display: "block",
                                    float: "left",
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontFamily: "Montserrat",
                                    textDecoration: "none",
                                    color: "white"
                                }}
                            >
                                FLOORING PRODUCTS
                            </Typography>
                            <span style={{ float: "right" }}>
                                {productListOpen ? (
                                    <ExpandLess htmlColor="white" />
                                ) : (
                                    <ExpandMore htmlColor="white" />
                                )}
                            </span>
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={productListOpen} timeout="auto" unmountOnExit>
                        <List component="div">
                            {floorProducts.map((p, i) => {
                                return (
                                    <ListItem key={`mobile_products_${i}`}>
                                        <ListItemButton sx={{ pl: 8 }}>
                                            <MobileNavItem href={p.href}>
                                                {p.title}
                                            </MobileNavItem>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Collapse>
                    <ListItem
                        key="mobile_equipment"
                        onClick={toggleEquipmentList}
                    >
                        <ListItemButton
                            sx={{ textAlign: "left", display: "block" }}
                        >
                            <Typography
                                color="primary"
                                sx={{
                                    display: "block",
                                    float: "left",
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontFamily: "Montserrat",
                                    textDecoration: "none",
                                    color: "white"
                                }}
                            >
                                Flooring Equipment
                            </Typography>
                            <span style={{ float: "right" }}>
                                {equipmentListOpen ? (
                                    <ExpandLess htmlColor="white" />
                                ) : (
                                    <ExpandMore htmlColor="white" />
                                )}
                            </span>
                        </ListItemButton>
                    </ListItem>
                    <Collapse
                        in={equipmentListOpen}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List component="div">
                            {equipment.map((p, i) => {
                                return (
                                    <ListItem key={`mobile_equipment_${i}`}>
                                        <ListItemButton sx={{ pl: 8 }}>
                                            <MobileNavItem href={p.href}>
                                                {p.title}
                                            </MobileNavItem>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Collapse>
                    <ListItem key="mobile_repairs">
                        <ListItemButton sx={{ textAlign: "left" }}>
                            <MobileNavItem href={urlToRepairs}>
                                Equipment Repair
                            </MobileNavItem>
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="mobile_rentals">
                        <ListItemButton sx={{ textAlign: "left" }}>
                            <MobileNavItem href={urlToRentals}>
                                Equipment Rental
                            </MobileNavItem>
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="mobile_about" onClick={toggleAbout}>
                        <ListItemButton
                            sx={{ textAlign: "left", display: "block" }}
                        >
                            <Typography
                                color="primary"
                                sx={{
                                    display: "block",
                                    float: "left",
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontFamily: "Montserrat",
                                    textDecoration: "none",
                                    color: "white"
                                }}
                            >
                                About
                            </Typography>
                            <span style={{ float: "right" }}>
                                {aboutOpen ? (
                                    <ExpandLess htmlColor="white" />
                                ) : (
                                    <ExpandMore htmlColor="white" />
                                )}
                            </span>
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={aboutOpen} timeout="auto" unmountOnExit>
                        <List component="div">
                            {about.map((p, i) => {
                                return (
                                    <ListItem key={`mobile_aout_${i}`}>
                                        <ListItemButton sx={{ pl: 8 }}>
                                            <MobileNavItem href={p.href}>
                                                {p.title}
                                            </MobileNavItem>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Collapse>

                    <ListItem key="mobile_contact">
                        <ListItemButton sx={{ textAlign: "left" }}>
                            <MobileNavItem href={urlToContactUs}>
                                Contact Us
                            </MobileNavItem>
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="mobile_resources" onClick={toggleResources}>
                        <ListItemButton
                            sx={{ textAlign: "left", display: "block" }}
                        >
                            <Typography
                                color="primary"
                                sx={{
                                    display: "block",
                                    float: "left",
                                    fontSize: "14px",
                                    textTransform: "uppercase",
                                    fontFamily: "Montserrat",
                                    textDecoration: "none",
                                    color: "white"
                                }}
                            >
                                Resources
                            </Typography>
                            <span style={{ float: "right" }}>
                                {aboutOpen ? (
                                    <ExpandLess htmlColor="white" />
                                ) : (
                                    <ExpandMore htmlColor="white" />
                                )}
                            </span>
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={resourcesOpen} timeout="auto" unmountOnExit>
                        <List component="div">
                            {resources.map((p, i) => {
                                return (
                                    <ListItem key={`mobile_resources_${i}`}>
                                        <ListItemButton sx={{ pl: 8 }}>
                                            <MobileNavItem href={p.href}>
                                                {p.title}
                                            </MobileNavItem>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Collapse>
                    <ListItem key="mobile_online_store">
                        <ListItemButton sx={{ textAlign: "left" }}>
                            <MobileNavItem href={urlToCatalogHome}>
                                Online Store
                            </MobileNavItem>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        </Drawer>
    );
};
